import { render } from "./navigation-bar.vue?vue&type=template&id=f8e23dd2&ts=true"
import script from "./navigation-bar.vue?vue&type=script&lang=ts"
export * from "./navigation-bar.vue?vue&type=script&lang=ts"

import "./navigation-bar.vue?vue&type=style&index=0&id=f8e23dd2&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__